import React from 'react';
import ReactGA from 'react-ga4';
import { Component } from 'react';

require('dotenv').config();


class Referral extends Component {

	state = {
		showDetails : false,
		errors : [],
	}

	isEmpty = (obj) => {
		for (var key in obj) {
			if (obj.hasOwnProperty(key))
				return false;
		}
		return true;
	}
	render() {
	if (this.props.userType === "dealer") {
			ReactGA.send({ hitType: "pageview", page: "/dealerReferralDetail" })
	};

	// Determine the appropriate message based on list state and user type
	const isListEmpty = !this.props.displayedList || this.props.displayedList.length === 0;

	let message;
	if (isListEmpty) {
		message = this.props.userType === "installer"
			? 'To create a new lead, click the "New Lead" button'
			: 'To create a new referral, click the "New Referral" button';
	} else {
		message = this.props.userType === "installer"
			? "Select a lead to claim or convert to an estimate."
			: "To view more detail of a referral, select one from the list.";
	}

	// if nothing selected, show instructional message
	if (this.isEmpty(this.props.selectedReferral) && this.props.action !== "add") {
		return (
			<h5 className="text-center p-3">
				{message}
			</h5>
		);
	}

	// if something selected, but selected item isn't in the displayed list, show message
	if (this.props.action !== "add") {
		const check = this.props.displayedList.filter(
			(item) => item.referral_id === this.props.selectedReferral.referral_id
		);
		if (check.length === 0) {
			return (
				<h5 className="text-center p-3">
					{message}
				</h5>
			);
		}
	}

			return (
				<React.Fragment>
					{this.props.action === "add" && <div className="row">
                        <div className="col text-center">
                            <h4>{this.props.userType === "installer" ? "Enter Lead Details" : "Enter Referral Details"}</h4>
                        </div>
                    </div>}

				</React.Fragment>
			);
		}
}

export default Referral;
